// src/pages/Pricing.js
import React from 'react';

const Pricing = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-green-100 p-8">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">Pricing Page</h1>
        <p className="text-xl">This is the pricing section of our website.</p>
      </div>
    </div>
  );
};

export default Pricing;
